module.exports = __webpack_public_path__ + "static/media/logo.0a857069.svg";